import React from 'react';
import VisibilityIcon from '@mui/icons-material/Visibility';
import PlayCircleFilled from '@mui/icons-material/PlayCircleFilled';
import LOOKUP from 'constants/lookup';
// Basic Components
import Button from 'screens/components/basic/Button';
import DatePickerInput from 'screens/components/basic/DatePickerInput';
import BranchMultiSelectAutoCompleteInput from 'screens/components/basic/BranchMultiSelectAutoCompleteInput';
import CardSimple from 'screens/components/basic/CardSimple';

const componentName = "EndOfDayReport";

const Header = (props) => {
    const { branchOptions, defaultBranch, toggleDrawer } = props;
    return (
        <CardSimple className="p-1">
            <div className="row">
                <div className="col-xs-6 col-sm-3">
                    <DatePickerInput
                        name={componentName + LOOKUP.report.common.beginDate.name}
                        floatingLabelText={LOOKUP.report.common.beginDate.label + "*"}
                        hintText={LOOKUP.report.common.beginDate.label + "*"}
                        fullWidth={true}
                    />
                </div>
                <div className="col-xs-6 col-sm-3">
                    <DatePickerInput
                        name={componentName + LOOKUP.report.common.endDate.name}
                        floatingLabelText={LOOKUP.report.common.endDate.label + "*"}
                        hintText={LOOKUP.report.common.endDate.label + "*"}
                        fullWidth={true}
                    />
                </div> {/* .col */}
                <div className="col-xs-12 col-sm-6">
                    <BranchMultiSelectAutoCompleteInput
                        defaultValues={defaultBranch}
                        name={`${componentName}Locations`}
                        fullWidth={true}
                        autoWidth={true}
                        label="Locations"
                        floatingLabelText="Select Location(s)"
                        hintText="Select locations to display"
                        style={{ fontFamily: "Open Sans, Arial, Helvetica, sans-serif", fontSize: "16px", letterSpacing: "-0.25px" }}
                        options={branchOptions}
                        fieldName={'Locations'}
                    />
                </div> {/* .col */}
                <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                    <Button
                        type="IconInButton"
                        className="pull-right mt-1 ml-1 btnNewBrandPOS"
                        name={componentName + LOOKUP.report.common.reportAutomation.name}
                        label={LOOKUP.report.common.reportAutomation.label}
                        icon={<PlayCircleFilled />}
                        onTouchTap={() => toggleDrawer()}
                    />
                    <Button
                        type="IconInButton"
                        className="pull-right mt-1 ml-1 btnNewBrandPOS"
                        name={componentName + LOOKUP.report.common.viewReport.name}
                        label={LOOKUP.report.common.viewReport.label}
                        icon={<VisibilityIcon />}
                        onTouchTap={props.showBody}
                    />
                    <Button
                        type="DownloadButton"
                        className="pull-right mt-1 btnNewBrandPOS"
                        name={componentName + LOOKUP.report.common.downloadReport.name}
                        label={LOOKUP.report.common.downloadReport.label}
                        onTouchTap={props.download}
                    />
                </div>
                <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 pt-3">
                    <p className='purpleText'><b>Note: </b><strong className="blue-text"><i>Please close the cash registers before running this report.</i></strong></p>
                </div>
            </div>
        </CardSimple>
    )
};

export default Header;
